import { getColor } from '../../../../utils/colors.mjs';
import { AVATAR_PRESET_COLOR_RECORD, PRESET_PREFIX } from '../constants/color.mjs';
import { isAvatarPresetColor, isPresetColor } from './cast.mjs';

function getAvatarBackground(params) {
  const { color, colorScheme = "default" } = params;
  if (!isAvatarPresetColor(color)) {
    return getColor(color);
  }
  const presetColor = toPresetColor(color);
  return AVATAR_PRESET_COLOR_RECORD[colorScheme][presetColor];
}
const FALLBACK_RANDOM_AVATAR_COLOR = AVATAR_PRESET_COLOR_RECORD.default.yellow;
function getRandomAvatarColor(params) {
  const { key, colorScheme = "default" } = params;
  if (key === "" || key.trim().length === 0) {
    return FALLBACK_RANDOM_AVATAR_COLOR;
  }
  const avatarPresetColors = Object.values(
    AVATAR_PRESET_COLOR_RECORD[colorScheme]
  );
  const lastCharacterOfKey = key.charAt(key.length - 1);
  const index = lastCharacterOfKey.charCodeAt(0) % avatarPresetColors.length;
  if (Number.isNaN(index)) {
    return FALLBACK_RANDOM_AVATAR_COLOR;
  }
  const pickedRandomAvatarPresetColor = avatarPresetColors[index];
  if (pickedRandomAvatarPresetColor === void 0) {
    return FALLBACK_RANDOM_AVATAR_COLOR;
  }
  return pickedRandomAvatarPresetColor;
}
function toPresetColor(avatarPresetColor) {
  const pascalCasedPresetColor = avatarPresetColor.split(PRESET_PREFIX)[1];
  const presetColorLoweredFirstCharacter = pascalCasedPresetColor?.[0]?.toLowerCase();
  const presetColorLastCharacter = pascalCasedPresetColor?.slice(1);
  const camelCasedPresetColor = `${presetColorLoweredFirstCharacter}${presetColorLastCharacter}`;
  if (!isPresetColor(camelCasedPresetColor)) {
    throw new Error(
      `[toPresetColor] ${camelCasedPresetColor}\uB294 \uC815\uC758\uB418\uC9C0 \uC54A\uC740 \uC720\uD615\uC758 \uC0C9\uC0C1\uC774\uC5D0\uC694.`
    );
  }
  return camelCasedPresetColor;
}

export { getAvatarBackground, getRandomAvatarColor, toPresetColor };
//# sourceMappingURL=color.mjs.map
